module.exports = __webpack_public_path__ + "static/media/Tutoriel outil analyse.3987ec3b.pdf";